<template>
    <div>
      个人中心
      <Footer></Footer>
    </div>
</template>

<script>
    import Footer from "../components/Footer";
    export default {
        name: "Mine",
      components: {Footer}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Mine.vue